import { createSlice } from '@reduxjs/toolkit';

const defaultModel = {
  customizationsSupported: [],
  guardrailsSupported: true,
  inferenceTypesSupported: ["ON_DEMAND"],
  inputModalities: ["TEXT"],
  modelArn: "arn:aws:bedrock:us-east-1::foundation-model/anthropic.claude-instant-v1",
  modelId: "anthropic.claude-instant-v1",
  modelLifecycle: {
    status: "ACTIVE",
  },
  modelName: "Claude Instant",
  outputModalities: ["TEXT"],
  providerName: "Anthropic",
  responseStreamingSupported: true,
};

const initialState = {
  history: [],
  sessionId: undefined,
  selectedModel: defaultModel,
  forceNewSession: false,
};

/**
 * Chat slice for managing chat state
 *
 * Handles chat history, session management, and model selection.
 * No localStorage persistence - chat state is loaded from backend.
 */
const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    addMessage: (state, action) => {
      state.history.push(action.payload);
    },
    setHistory: (state, action) => {
      state.history = action.payload;
    },
    clearHistory: (state) => {
      state.history = [];
    },
    setSessionId: (state, action) => {
      state.sessionId = action.payload;
    },
    setSelectedModel: (state, action) => {
      state.selectedModel = action.payload;
    },
    resetChat: (state) => {
      state.history = [];
      state.sessionId = undefined;
      state.forceNewSession = true;  // Next message should force new session
    },
    clearForceNewSession: (state) => {
      state.forceNewSession = false;
    },
    updateMessageRating: (state, action) => {
      const { messageId, rating } = action.payload;
      const message = state.history.find(msg => msg.id === messageId);
      if (message) {
        // Initialize ratings array if it doesn't exist
        if (!message.ratings) {
          message.ratings = [];
        }
        // Replace existing rating (since only one rating per message is allowed)
        message.ratings = [rating];
      }
    },
  },
});

export const {
  addMessage,
  setHistory,
  clearHistory,
  setSessionId,
  setSelectedModel,
  resetChat,
  clearForceNewSession,
  updateMessageRating,
} = chatSlice.actions;

export default chatSlice.reducer;

// Selectors
export const selectChatHistory = (state) => state.chat.history;
export const selectSessionId = (state) => state.chat.sessionId;
export const selectSelectedModel = (state) => state.chat.selectedModel;
export const selectForceNewSession = (state) => state.chat.forceNewSession;
